// node-modules
import React from 'react';
import { Button, Divider, Text, View } from '@upstox/upstox-ui';
// hooks
import useCurrentTheme from 'utils/hooks/useCurrentTheme';
// services
import LocaleService from 'modules/Localization';
// assets
import UploadSuccessIcon from 'assets/upload-success-icon.svg';
import UploadSuccessIconDark from 'assets/upload-success-icon-dark.svg';
import * as css from '../../styles';

interface ChartSyncSuccessProps {
  onDone: () => void;
}

const ChartSyncSuccess = ({ onDone }: ChartSyncSuccessProps) => {
  const currentTheme = useCurrentTheme();
  return (
    <React.Fragment>
      <View justifyContent="center">
        <img
          src={
            currentTheme === 'dark' ? UploadSuccessIconDark : UploadSuccessIcon
          }
          alt="Upload Success Icon"
        />
      </View>
      <View
        padding={['large', 'xxxlarge']}
        flexDirection="column"
        gap="small"
        alignItems="center"
      >
        <Text css={css.heading}>
          {LocaleService.translate('UPLOADED_SUCCESSFULLY')}
        </Text>
        <Text css={css.description}>
          {LocaleService.translate('UPLOADING_TO_CLOUD_SUCCESS')}
        </Text>
      </View>
      <Divider />
      <View padding="medium" justifyContent="center">
        <Button
          onClick={onDone}
          style={{ borderRadius: '4px', width: '120px' }}
          size="small"
        >
          Done
        </Button>
      </View>
    </React.Fragment>
  );
};

export default ChartSyncSuccess;
